import { defineMessages } from 'react-intl';

const messages = defineMessages({
  translated_currency: '币种',
  translated_invoice_type: '开具发票类型',
  contract_begin_at: '合同生效日期',
  effective_date: '合同生效日期',
  due_date: '合同到期日期',
  contract_end_at: '合同到期日期',
  contract: '合同',
  noData: '暂无',
  code: '编号',
  upper_limit: '上限',
  balance: '余额',
  unitRMB: '元',
});

export default messages;
